<template>
  <div>
    <div class="dac-category form-group">
      <label class="dac-option" :class="{ 'dac-option--selected': isBank }" v-show="updatability || isBank">
        <input type="radio" class="dac-option__input" id="destination_account_category_bank"
          name="destination_account[category]" value="bank" v-model="form.category" />
        <span class="dac-option__icon material-icons-sharp" aria-hidden="true">account_balance</span>
        <span class="dac-option__text">
          <span class="dac-option__title">{{ $t("add_contact_page.bank_account") }}</span>
          <span class="dac-option__desc">{{ $t("add_contact_page.bank_account_desc") }}</span>
        </span>
        <span class="dac-option__radio" aria-hidden="true"></span>
      </label>

      <label class="dac-option" :class="{ 'dac-option--selected': form.category === 'wallet' }"
        v-show="updatability || !isBank">
        <input type="radio" class="dac-option__input" id="destination_account_category_wallet"
          name="destination_account[category]" value="wallet" v-model="form.category" />
        <span class="dac-option__icon material-icons-sharp" aria-hidden="true">account_balance_wallet</span>
        <span class="dac-option__text">
          <span class="dac-option__title">{{ $t("add_contact_page.crypto_account") }}</span>
          <span class="dac-option__desc">{{ $t("add_contact_page.crypto_account_desc") }}</span>
        </span>
        <span class="dac-option__radio" aria-hidden="true"></span>
      </label>

      <label class="dac-option" :class="{ 'dac-option--selected': isArcadi }" v-show="updatability">
        <input type="radio" class="dac-option__input" id="destination_account_category_arcadi"
          name="destination_account[category]" value="arcadi" v-model="form.category" />
        <span class="dac-option__icon material-icons-sharp" aria-hidden="true">flash_on</span>
        <span class="dac-option__text">
          <span class="dac-option__title">{{ $t("add_contact_page.arcadi_account") }}</span>
          <span class="dac-option__desc">{{ $t("add_contact_page.arcadi_account_desc") }}</span>
        </span>
        <span class="dac-option__radio" aria-hidden="true"></span>
      </label>
    </div>

    <hr class="my-6" style="border-color: var(--font-color-primary); opacity: 0.15;" />

    <div v-show="!updatability" class="bank-static-message">
      <div class="mb-8 arcadi-disclaimer bank-static-message">
        <img :src="images.arcadiAlert" class="inline w-8 mr-2" />
        <span v-html="$t('add_contact_page.form.not_updatability')"></span>
      </div>
    </div>

    <div v-show="updatability" class="text-lg mt-1 mb-4 font-bold" style="color: var(--font-color-primary); opacity: 0.7;">
      {{ instructionsText }}
    </div>

    <!-- Campos para Cuenta Arcadi -->
    <div v-if="isArcadi">
      <input type="hidden" name="source" value="destination_accounts" />
      <div class="form-group">
        <label for="internal_contact_email" class="edit-profile_form_label">
          {{ $t("add_contact_page.form.arcadi_email") }}
        </label>
        <input v-model="form.arcadi_email" type="email" class="mt-2 arcadi-input mb-4 arcadi-form__input"
          id="internal_contact_email"
          name="internal_contact[email]" :placeholder="$t('add_contact_page.form.arcadi_email_placeholder')" />
      </div>
      <div class="form-group">
        <label for="internal_contact_alias" class="edit-profile_form_label">
          {{ $t("add_contact_page.form.arcadi_alias") }}
        </label>
        <input v-model="form.arcadi_alias" type="text" class="mt-2 arcadi-input mb-4 arcadi-form__input"
          id="internal_contact_alias"
          name="internal_contact[alias]" :placeholder="$t('add_contact_page.form.arcadi_alias_placeholder')" />
      </div>
    </div>

    <!-- Campos para Bank/Wallet -->
    <div v-show="!isArcadi">
    <div class="form-group">
      <label for="destination_account_alias" class="edit-profile_form_label">
        {{ aliasLabel }}
      </label>
      <input v-model="form.alias" type="text" class="mt-2 arcadi-input"
        :class="{ 'mb-4 arcadi-form__input ': !errors.alias }" id="destination_account_alias"
        name="destination_account[alias]" :placeholder="aliasLabel" :disabled="!updatability" />
      <span class="error-destination" v-if="errors.alias">{{
        `Alias ${errors.alias[0]}`
      }}</span>
    </div>
    <div v-show="isBank" class="form-group">
      <label for="destination_account_name" class="edit-profile_form_label">
        {{ $t("add_contact_page.form.account_name") }}
      </label>
      <input v-model="form.recipient_first_name" type="text" class="mt-2 arcadi-input"
        :class="{ 'mb-4 arcadi-form__input ': !errors.recipient_first_name }"
        id="destination_account_recipient_first_name" name="destination_account[recipient_first_name]"
        :placeholder="$t('add_contact_page.form.account_name')" :disabled="!updatability" />
      <span class="error-destination" v-if="errors.recipient_first_name">{{
        `${$t("add_contact_page.form.account_name")} ${errors.recipient_first_name[0]
        }`
      }}</span>
    </div>
    <div v-show="isBank && updatability" class="bank-static-message">
      <div class="mb-8 arcadi-disclaimer bank-static-message">
        <img :src="images.arcadiAlert" class="inline w-8 mr-2" />
        <span v-html="$t('add_contact_page.form.account_name_alert')"></span>
      </div>
    </div>
    <div v-show="isBank" class="form-group">
      <label for="destination_account_number" class="edit-profile_form_label">
        {{ $t("add_contact_page.form.account_last_name") }}
      </label>
      <input v-model="form.recipient_last_name" type="text" class="mt-2 arcadi-input"
        :class="{ 'mb-4 arcadi-form__input ': !errors.recipient_last_name }"
        id="destination_account_recipient_last_name" name="destination_account[recipient_last_name]"
        :placeholder="$t('add_contact_page.form.account_last_name')" :disabled="!updatability" />
      <span class="error-destination" v-if="errors.recipient_last_name">{{
        `${$t("add_contact_page.form.account_last_name")} ${errors.recipient_last_name[0]
        }`
      }}</span>
    </div>
    <div v-show="isBank && updatability" class="bank-static-message">
      <div class="mb-8 arcadi-disclaimer bank-static-message">
        <img :src="images.arcadiAlert" class="inline w-8 mr-2" />
        <span v-html="$t('add_contact_page.form.account_last_name_alert')"></span>
      </div>
    </div>
    <label v-show="isBank" for="destination_account_number" class="edit-profile_form_label">
      {{ $t("add_contact_page.form.identification_type.title") }}
    </label>
    <div v-show="isBank" class="form-group arcadi-select">
      <select v-model="form.recipient_id_type" class="mt-2 arcadi-input screen-select:appearance-none"
        :class="{ 'mb-4 arcadi-form__input ': !errors.recipient_id_type }" id="destination_account_recipient_id_type"
        name="destination_account[recipient_id_type]" :disabled="!updatability">
        <option value="">{{ $t('add_contact_page.form.select_option') }}</option>
        <option v-for="(identityType, key) in identityTypes" :key="key" :value="identityType[1]">
          {{ translateIdentity(identityType[0]) }}
        </option>
      </select>
      <span class="error-destination" v-if="errors.recipient_id_type">{{
        `${$t("add_contact_page.form.identification_type.title")} ${errors.recipient_id_type[0]
        }`
      }}</span>
    </div>
    <div v-show="isBank" class="form-group">
      <label for="destination_account_number" class="edit-profile_form_label">
        {{ $t("add_contact_page.form.identification_number") }}
      </label>
      <input v-model="form.recipient_id" type="text" class="mt-2 arcadi-input"
        :class="{ 'mb-4 arcadi-form__input': !errors.recipient_id }" id="destination_account_recipient_id"
        name="destination_account[recipient_id]" :placeholder="$t('add_contact_page.form.identification_number')"
        :disabled="!updatability" />
      <span class="error-destination" v-if="errors.recipient_id">{{
        `${$t("add_contact_page.form.identification_number")} ${errors.recipient_id[0]
        }`
      }}</span>
    </div>
    <div v-show="isBank && canUpdate" class="bank-static-message">
      <div class="mb-8 arcadi-disclaimer bank-static-message">
        <img :src="images.arcadiAlert" class="inline w-8 mr-2" />
        <span v-html="$t('add_contact_page.form.identification_number_alert')"></span>
      </div>
    </div>
    <label for="destination_account_number" class="edit-profile_form_label">
      {{ countryText }}
    </label>
    <div class="form-group arcadi-select">
      <select v-model="form.country_id" class="mt-2 arcadi-input screen-select:appearance-none"
        :class="{ 'mb-4 arcadi-form__input': !errors.country_id }" id="destination_account_country_id"
        name="destination_account[country_id]" :disabled="!updatability" @change="getBankByCountry">
        <option value="0">{{ $t('add_contact_page.form.select_option') }}</option>
        <option v-for="(country, key) in countries" :key="key" :value="country.id">
          {{ country.name }}
        </option>
      </select>
      <span class="error-destination" v-if="errors.country_id">{{
        `${countryText} ${errors.country_id[0]}`
      }}</span>
    </div>
    <!-- Sin países el formulario entero es inservible (no hay país -> no hay
         banco -> no se puede guardar): agotados los reintentos, avisar y
         ofrecer Reintentar en vez de dejar un selector vacío y mudo. -->
    <div v-if="countryLoadState === 'error'" role="alert"
      class="mb-8 arcadi-disclaimer bank-static-message flex-wrap">
      <div class="flex items-center" style="flex: 1 1 200px;">
        <img :src="images.arcadiAlert" alt="" class="inline w-8 mr-2 flex-shrink-0" />
        <span>{{ countriesLoadErrorText }}</span>
      </div>
      <button type="button"
        class="arcadi-button arcadi-button--small text-white w-full mt-3 sm:w-auto sm:mt-0 sm:ml-3"
        @click="retryLoadCountries">
        {{ $t("add_contact_page.form.banks_load_retry") }}
      </button>
    </div>
    <div v-show="isBank" class="form-group">
      <label for="destination_account_number" class="edit-profile_form_label">
        {{ $t("add_contact_page.form.city_text") }}
      </label>
      <input v-model="form.recipient_city" type="text" class="mt-2 arcadi-input"
        :class="{ 'mb-4 arcadi-form__input': !errors.recipient_city }" id="destination_account_recipient_city"
        name="destination_account[recipient_city]" :placeholder="$t('add_contact_page.form.city_text')"
        :disabled="!updatability" />
      <span class="error-destination" v-if="errors.recipient_city">{{
        `${$t("add_contact_page.form.city_text")} ${errors.recipient_city[0]}`
      }}</span>
    </div>
    <div v-show="!hiddenOptionals && isBank && (newUser || (canUpdate && form.recipient_state))" class="form-group">
      <label for="destination_account_number" class="edit-profile_form_label">
        {{ $t("add_contact_page.form.state_text") }}
      </label>
      <input v-model="form.recipient_state" type="text" class="mt-2 arcadi-input"
        :class="{ 'mb-4 arcadi-form__input': !errors.recipient_state }" id="destination_account_recipient_state"
        name="destination_account[recipient_state]" :placeholder="$t('add_contact_page.form.state_text')"
        :disabled="!updatability" />
      <span class="error-destination" v-if="errors.recipient_state">{{
        `${$t("add_contact_page.form.state_text")} ${errors.recipient_state[0]}`
      }}</span>
    </div>
    <div v-show="isBank" class="form-group">
      <label for="destination_account_number" class="edit-profile_form_label">
        {{ $t("add_contact_page.form.address_text") }}
      </label>
      <input v-model="form.recipient_home_address" type="text" class="mt-2 arcadi-input"
        :class="{ 'mb-4 arcadi-form__input': !errors.recipient_home_address }"
        id="destination_account_recipient_home_address" name="destination_account[recipient_home_address]"
        :placeholder="$t('add_contact_page.form.address_text')" :disabled="!updatability" />
      <span class="error-destination" v-if="errors.recipient_home_address">{{
        `${$t("add_contact_page.form.address_text")} ${errors.recipient_home_address[0]
        }`
      }}</span>
    </div>
    <div v-show="!hiddenOptionals && isBank && (newUser || (canUpdate && form.recipient_phone))" class="form-group">
      <label for="destination_account_number" class="edit-profile_form_label">
        {{ $t("add_contact_page.form.phone_text") }}
      </label>
      <input v-model="form.recipient_phone" type="text" class="mt-2 arcadi-input"
        :class="{ 'mb-4 arcadi-form__input ': !errors.recipient_phone }" id="destination_account_recipient_phone"
        name="destination_account[recipient_phone]" :placeholder="$t('add_contact_page.form.phone_text')"
        :disabled="!updatability" />
      <span class="error-destination" v-if="errors.recipient_phone">{{
        `${$t("add_contact_page.form.phone_text")} ${errors.recipient_phone[0]}`
      }}</span>
    </div>
    <div v-show="!hiddenOptionals && isBank && (newUser || (canUpdate && form.recipient_birthdate))" class="form-group">
      <label for="destination_account_recipient_birthdate" class="edit-profile_form_label">
        {{ $t("add_contact_page.form.birthdate_text") }}
      </label>
      <input v-model="form.recipient_birthdate" type="text"
        class="mt-2 arcadi-input arcadi-input--destination-account-date flatpickr-input"
        :class="{ 'mb-4 arcadi-form__input': !errors.recipient_birthdate }" id="destination_account_recipient_birthdate"
        name="destination_account[recipient_birthdate]" :placeholder="$t('add_contact_page.form.birthdate_text')"
        :disabled="!updatability" />
      <span class="error-destination" v-if="errors.recipient_birthdate">{{
        `${$t("add_contact_page.form.birthdate_text")} ${errors.recipient_birthdate[0]
        }`
      }}</span>
    </div>
    <label for="destination_account_number" class="edit-profile_form_label">
      {{ destinationAccountText }}
    </label>
    <div class="form-group arcadi-select">
      <select v-model="form.destination_account_bank_id" class="mt-2 arcadi-input screen-select:appearance-none" :class="{
        'mb-4 arcadi-form__input': !errors.destination_account_bank_id
      }" id="destination_account_destination_account_bank_id" name="destination_account[destination_account_bank_id]"
        :disabled="!updatability">
        <option value="0">{{ $t('add_contact_page.form.select_option') }}</option>
        <option v-for="(bank, key) in banks" :key="key" :value="bank.id">
          {{ bank.name }}
        </option>
      </select>
      <span class="error-destination" v-if="errors.destination_account_bank_id">{{
        `${destinationAccountText} ${errors.destination_account_bank_id[0]}`
      }}</span>
    </div>
    <!-- Estados de la carga de bancos (ARCADI-EB): mientras carga/reintenta,
         un aviso sutil; agotados los reintentos, aviso honesto + Reintentar.
         Nunca un selector vacío y mudo. -->
    <div v-if="bankLoadState === 'loading'" role="status" class="mb-4 text-sm font-color-primary"
      style="opacity: 0.65;">
      {{ banksLoadingText }}
    </div>
    <!-- flex-wrap + basis en el grupo ícono/texto: en pantallas angostas
         (320px) el botón baja a su propia fila a ancho completo en vez de
         estrujar el mensaje en una columna de pocos caracteres. -->
    <div v-if="bankLoadState === 'error'" role="alert"
      class="mb-8 arcadi-disclaimer bank-static-message flex-wrap">
      <div class="flex items-center" style="flex: 1 1 200px;">
        <img :src="images.arcadiAlert" alt="" class="inline w-8 mr-2 flex-shrink-0" />
        <span>{{ banksLoadErrorText }}</span>
      </div>
      <button type="button"
        class="arcadi-button arcadi-button--small text-white w-full mt-3 sm:w-auto sm:mt-0 sm:ml-3"
        @click="retryLoadBanks">
        {{ $t("add_contact_page.form.banks_load_retry") }}
      </button>
    </div>
    <div v-show="destinationAccountWarning" class="bank-static-message">
      <div class="mb-8 arcadi-disclaimer bank-static-message">
        <img :src="images.arcadiAlert" class="inline w-8 mr-2" />
        <span v-html="destinationAccountWarning"></span>
      </div>
    </div>
    <div v-show="isUnitedStates && isBank && (newUser || canUpdate)
        " class="form-group">
      <label for="destination_account_number" class="edit-profile_form_label">
        {{ $t("add_contact_page.form.number_aba") }}
      </label>
      <input v-model="form.aba_number" type="text" class="mt-2 arcadi-input"
        :class="{ 'mb-4 arcadi-form__input ': !errors.aba_number }" id="destination_account_aba_number"
        name="destination_account[aba_number]" :placeholder="$t('add_contact_page.form.number_aba')"
        :disabled="!updatability" />
      <span class="error-destination" v-if="errors.aba_number">{{
        `${$t("add_contact_page.form.number_aba")} ${errors.aba_number[0]}`
      }}</span>
    </div>
    <div v-show="isUnitedStates && isBank && (newUser || canUpdate)
        " class="bank-static-message">
      <div class="mb-8 arcadi-disclaimer bank-static-message">
        <img :src="images.arcadiAlert" class="inline w-8 mr-2" />
        <span v-html="$t('add_contact_page.form.aba_warning')"></span>
      </div>
    </div>
    <div v-show="isSpain && isBank && (newUser || canUpdate)" class="form-group">
      <label for="destination_account_iban_number" class="edit-profile_form_label">
        {{ $t("add_contact_page.form.number_iban") }}
      </label>
      <input v-model="form.iban_number" type="text" class="mt-2 arcadi-input"
        :class="{ 'mb-4 arcadi-form__input ': !errors.iban_number }" id="destination_account_iban_number"
        name="destination_account[iban_number]" :placeholder="$t('add_contact_page.form.number_iban')"
        :disabled="!updatability" />
      <span class="error-destination" v-if="errors.iban_number">{{
        `${$t("add_contact_page.form.number_iban")} ${errors.iban_number[0]}`
      }}</span>
    </div>
    <div v-show="false && isBrasil && isBank && (newUser || canUpdate)" class="form-group">
      <label for="destination_account_cpf_number" class="edit-profile_form_label">
        {{ $t("add_contact_page.form.number_cpf") }}
      </label>
      <input v-model="form.cpf_number" type="text" class="mt-2 arcadi-input"
        :class="{ 'mb-4 arcadi-form__input ': !errors.cpf_number }" id="destination_account_cpf_number"
        name="destination_account[cpf_number]" :placeholder="$t('add_contact_page.form.number_cpf')"
        :disabled="!updatability" />
      <span class="error-destination" v-if="errors.cpf_number">{{
        `${$t("add_contact_page.form.number_cpf")} ${errors.cpf_number[0]}`
      }}</span>
    </div>
    <div v-show="isBrasil && isBank && (newUser || canUpdate)" class="form-group">
      <label for="destination_account_pix_number" class="edit-profile_form_label">
        {{ $t("add_contact_page.form.pix_key") }}
      </label>
      <input v-model="form.pix_key" type="text" class="mt-2 arcadi-input"
        :class="{ 'mb-4 arcadi-form__input ': !errors.cpf_number }" id="destination_account_pix_number"
        name="destination_account[pix_key]" :placeholder="$t('add_contact_page.form.pix_key')"
        :disabled="!updatability" />
      <span class="error-destination" v-if="errors.pix_key">{{
        `${$t("add_contact_page.form.pix_key")} ${errors.pix_key[0]}`
      }}</span>
    </div>
    <div v-if="!isBrasil">
      <label v-show="isBank" for="destination_account_account_type" class="edit-profile_form_label">
        {{ $t("add_contact_page.form.account_type") }}
      </label>
      <div v-show="isBank" class="form-group arcadi-select">
        <select v-model="form.account_type" class="mt-2 arcadi-input screen-select:appearance-none"
          :class="{ 'mb-4 arcadi-form__input': !errors.account_type }" id="destination_account_account_type"
          name="destination_account[account_type]" :disabled="!updatability">
          <option value="0">{{ $t('add_contact_page.form.select_option') }}</option>
          <option v-for="(accountType, key) in accountTypes" :key="key" :value="accountType[1]">
            {{ accountType[0] }}
          </option>
        </select>

        <span class="error-destination" v-if="errors.account_type">{{
          `${$t("add_contact_page.form.account_type")} ${errors.account_type[0]}`
        }}</span>
      </div>
    </div>
    <div v-show="isBank && !isBrasil" class="form-group">
      <label for="destination_account_number" class="edit-profile_form_label">
        {{ $t("add_contact_page.form.account_number") }}
      </label>
      <input v-model="form.number" type="text" class="mt-2 arcadi-input"
        :class="{ 'mb-4 arcadi-form__input': !errors.number }" id="destination_account_number"
        name="destination_account[number]" :placeholder="$t('add_contact_page.form.account_number')"
        :disabled="!updatability" />
      <span class="error-destination" v-if="errors.number">{{
        `${$t("add_contact_page.form.account_number")} ${errors.number[0]}`
      }}</span>
    </div>
    <div v-show="isBank && isPeru" class="bank-static-message">
      <div class="mb-8 arcadi-disclaimer bank-static-message">
        <img :src="images.arcadiAlert" class="inline w-8 mr-2" />
        <span v-html="$t('add_contact_page.form.peru_warning')"></span>
      </div>
    </div>
    <div v-show="!hiddenOptionals && isBank && (newUser || (canUpdate && form.recipient_email))" class="form-group">
      <label for="destination_account_number" class="edit-profile_form_label">
        {{ $t("add_contact_page.form.email_destination") }}
      </label>
      <input v-model="form.recipient_email" type="text" class="mt-2 arcadi-input"
        :class="{ 'mb-4 arcadi-form__input': !errors.recipient_email }" id="destination_account_recipient_email"
        name="destination_account[recipient_email]" :placeholder="$t('add_contact_page.form.email_destination')"
        :disabled="!updatability" />
      <span class="error-destination" v-if="errors.recipient_email">{{
        `${$t("add_contact_page.form.email_destination")} ${errors.recipient_email[0]
        }`
      }}</span>
    </div>
    <div v-if="!isBrasil" v-show="newUser || canUpdate || form.additional_data" class="form-group">
      <label for="destination_account_number" class="edit-profile_form_label">
        {{ additionalDataText }}
      </label>
      <textarea v-model="form.additional_data" type="text" class="mt-2 arcadi-input"
        :class="{ 'mb-4 arcadi-form__input': !errors.additional_data }" id="destination_account_additional_data"
        name="destination_account[additional_data]" :placeholder="additionalDataText" :disabled="!updatability">
      </textarea>
      <span class="error-destination" v-if="errors.additional_data">{{
        `${additionalDataText} ${errors.additional_data[0]}`
      }}</span>
    </div>
    <div v-show="additionalDataWarning" class="bank-static-message">
      <div class="mb-8 arcadi-disclaimer bank-static-message">
        <img :src="images.arcadiAlert" class="inline w-8 mr-2" />
        <span v-html="additionalDataWarning"></span>
      </div>
    </div>
    <input type="hidden" name="destination_account[personal_account]" :value="personalAccount"
      v-show="personalAccount" />
    <div v-show="canUpdate && !isArcadi">
      <label for="info_checked" class="flex edit-profile_form_label">
        <input type="checkbox" id="info_checked" name="info_checked" class="mx-1" value="bank" v-model="infoChecked" />
        {{ $t("add_contact_page.form.confirm_button") }}
      </label>
    </div>
    </div><!-- cierre de v-show="!isArcadi" -->
  </div>
</template>

<script>
import FormApi from "../../../api/form";
import flatpickr from "flatpickr";
import { Spanish } from "flatpickr/dist/l10n/es";

import arcadiAlert from "../../../../assets/images/arcadi-alert.svg"

export default {
  props: {
    destinationAccount: {
      type: Object,
      required: false,
      default: () => ({})
    },
    identityTypes: {
      type: Array,
      required: true
    },
    accountTypes: {
      type: Array,
      required: true
    },
    countriesCodes: {
      type: Object,
      required: true
    },
    accountCountryCode: {
      type: Number,
      required: false,
      default: 0
    },
    errors: {
      type: Object,
      required: false,
      default: () => ({})
    },
    updatability: {
      type: Boolean,
      required: false,
      default: true
    },
    personalAccount: {
      type: Boolean,
      required: false,
      default: false
    },
    initialCategory: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      countries: [],
      infoChecked: false,
      banks: [],
      // idle | loading | ok | error — estado explícito de la carga de bancos;
      // 'error' = reintentos agotados → aviso inline + botón Reintentar.
      bankLoadState: 'idle',
      // Generación de cada cadena de carga (ver loadListWithRecovery): toda
      // entrada nueva la incrementa e invalida timers/respuestas anteriores.
      bankLoadSeq: 0,
      bankRetryTimer: null,
      countryLoadState: 'idle',
      countryLoadSeq: 0,
      countryRetryTimer: null,
      newUser: true,
      hiddenOptionals: true,
      images: {
        arcadiAlert: arcadiAlert
      },
      originalFormAction: null,
      form: {}
    };
  },
  computed: {
    aliasLabel() {
      return this.isBank
        ? this.$t("add_contact_page.form.alias")
        : this.$t("add_contact_page.form.wallet_contact");
    },
    additionalDataText() {
      return this.isBank
        ? this.$t("add_contact_page.form.additional_data")
        : this.$t("add_contact_page.form.wallet_address");
    },
    countryText() {
      return this.isBank
        ? this.$t("add_contact_page.form.country_text")
        : this.$t("add_contact_page.form.asset");
    },
    destinationAccountText() {
      return this.isBank
        ? this.$t("add_contact_page.form.choose_bank")
        : this.$t("add_contact_page.form.wallet_type");
    },
    // El mismo selector sirve bancos (categoría banco) y tipos de billetera
    // (cripto): los avisos de carga/error hablan del dominio que corresponde,
    // igual que countryText/destinationAccountText.
    banksLoadingText() {
      return this.isBank
        ? this.$t("add_contact_page.form.banks_loading")
        : this.$t("add_contact_page.form.wallets_loading");
    },
    banksLoadErrorText() {
      return this.isBank
        ? this.$t("add_contact_page.form.banks_load_error")
        : this.$t("add_contact_page.form.wallets_load_error");
    },
    // El mismo selector lista países (banco) o activos (cripto): ver countryText.
    countriesLoadErrorText() {
      return this.isBank
        ? this.$t("add_contact_page.form.countries_load_error")
        : this.$t("add_contact_page.form.assets_load_error");
    },
    instructionsText() {
      if (this.isArcadi) return this.$t("add_contact_page.instructions_arcadi");
      return this.isBank
        ? this.$t("add_contact_page.instructions")
        : this.$t("add_contact_page.instructions_2");
    },
    isBank() {
      return this.form.category === "bank";
    },
    isArcadi() {
      return this.form.category === "arcadi";
    },
    canUpdate() {
      return !isNaN(this.updatability) && this.updatability;
    },
    // ISO country code for the currently-selected destination country. Derived
    // from `countriesCodes` ({id => code}), which is passed in from the backend
    // (@countries_codes). Country IDs are auto-assigned by seed order and are
    // fragile to reference by literal (a re-seed or ID reassignment silently
    // breaks the country-specific branches below), so all downstream checks
    // read `countryCode` instead of `form.country_id`.
    countryCode() {
      return this.countriesCodes[this.form.country_id];
    },
    isBrasil() {
      return this.countryCode === 'BR';
    },
    isSpain() {
      return this.countryCode === 'ES';
    },
    isUnitedStates() {
      return this.countryCode === 'US';
    },
    isPeru() {
      return this.countryCode === 'PE';
    },
    destinationAccountWarning() {
      const warningWallet = {
        'ERC20': {
          'USDT': this.$t("add_contact_page.form.tether_erc20_warning"),
          'USDC': this.$t("add_contact_page.form.usdc_erc20_warning")
        },
        'TRC20': {
          'USDT': this.$t("add_contact_page.form.tether_tcr20_warning"),
          'USDC': this.$t("add_contact_page.form.usdc_tcr20_warning")
        }
      };
      const venezuelaBanks = [24, 17, 21, 19, 1, 0];

      const bank = this.banks.find(bank => bank.id === this.form.destination_account_bank_id);
      const country = this.countries.find(country => country.id === this.form.country_id);

      if (bank && country && warningWallet[bank.code] && warningWallet[bank.code][country.code])
        return warningWallet[bank.code][country.code];
      if (this.countryCode === 'VE' && !venezuelaBanks.includes(this.form.destination_account_bank_id))
        return this.$t("add_contact_page.form.venezuela_warning");
      return "";
    },
    additionalDataWarning() {
      const venezuelaBanks = [24, 17, 21, 19, 1, 0];
      const warningAdditional = {
        PE: this.$t("add_contact_page.form.additional_peru"),
        ES: this.$t("add_contact_page.form.additional_spain"),
        VE: this.$t("add_contact_page.form.additional_venezuela"),
        BR: this.$t("add_contact_page.form.additional_brasil")
      };
      if (warningAdditional[this.countryCode] && !venezuelaBanks.includes(this.form.destination_account_bank_id))
        return warningAdditional[this.countryCode];
      return "";
    }
  },
  beforeUnmount() {
    window.removeEventListener('online', this.handleConnectionRestored);
    // Un backoff en vuelo no debe disparar un fetch contra un componente muerto.
    if (this.bankRetryTimer) clearTimeout(this.bankRetryTimer);
    if (this.countryRetryTimer) clearTimeout(this.countryRetryTimer);
  },
  mounted() {
    // Si la carga de bancos quedó en error por falta de conexión, refrescar
    // apenas el navegador recupere la red (sin quemar reintentos a ciegas).
    window.addEventListener('online', this.handleConnectionRestored);
    const category = this.initialCategory || this.destinationAccount.category;
    this.initComponent(category);
    if (category === 'arcadi') {
      this.$nextTick(() => {
        this.originalFormAction = this.getFormElement()?.getAttribute('action');
        const formEl = this.getFormElement();
        if (formEl) {
          formEl.setAttribute('action', '/internal_contacts');
        }
        const saveButton = document.querySelector("#save-button-destination_account");
        if (saveButton) {
          saveButton.disabled = false;
        }
      });
    }
    const dateSelector = document.querySelector(
      ".arcadi-input--destination-account-date"
    );
    if (dateSelector) {
      const datePicker = flatpickr(".arcadi-input--destination-account-date", {
        locale: Spanish,
        disableMobile: "true",
        altFormat: "d \\de F \\de Y",
        altInput: true,
        dateFormat: "Y-m-d",
        maxDate: new Date()
      });
      const birthday = this.destinationAccount.recipient_birthdate;
      if (birthday) datePicker.setDate(birthday.replace(/"/g, ""));
    }
  },
  methods: {
    getBankByCountry() {
      this.form = { ...this.form };
      this.loadBanks();
    },
    // Carga de bancos con RECUPERACIÓN, no solo supervivencia (ARCADI-EB):
    // una respuesta no-lista (proxy/portal cautivo inyectando HTML con 200 —
    // el caso real del 25-jul: dos 200 en los breadcrumbs y aun así crash) o
    // un fetch caído entran a la rama de error y ahí el sistema USA lo que
    // sabe: reintenta solo (2 veces, backoff 1s/3s), y si el navegador está
    // offline no quema reintentos — espera el evento 'online' (listener en
    // mounted). Agotado todo, bankLoadState='error' muestra el aviso inline
    // con botón Reintentar: nunca más un selector vacío y mudo.
    // Un vacío LEGÍTIMO (lista [] real) NO reintenta: es un estado válido.
    //
    // La identidad de la cadena es `seq` (contador monótono), NO el país:
    // comparar por país dejaba revivir cadenas zombi (país A falla -> el
    // usuario va a B y vuelve a A dentro del backoff -> el timer viejo pasaba
    // el guard A===A y su fallo tardío borraba los bancos que la cadena nueva
    // ya había cargado, dejando el selector vacío con estado 'ok': justo el
    // estado mudo que este fix existe para eliminar). Cada entrada nueva
    // (cambio de país, Reintentar, vuelta de conexión) incrementa loadSeq e
    // invalida al instante todo timer y respuesta en vuelo; el backoff
    // re-entra con el MISMO seq porque es la misma cadena.
    // Núcleo compartido por las DOS listas remotas del formulario (países y
    // bancos): ambas llegan por el mismo canal y el mismo portal cautivo que
    // corrompe una corrompe la otra. Blindar solo bancos dejaba la puerta de
    // al lado abierta — con `countries` corrupto el componente moría antes de
    // que esta misma UI de recuperación pudiera mostrarse.
    //
    // config: { stateProp, seqProp, timerProp, request(), assign(lista) }
    loadListWithRecovery(config, attempt = 0, seq = null) {
      const chainSeq = seq === null ? (this[config.seqProp] += 1) : seq;
      this[config.stateProp] = 'loading';

      config.request().then(response => {
        if (chainSeq !== this[config.seqProp]) return; // cadena obsoleta
        if (!Array.isArray(response.data)) throw new Error('non-array list payload');
        config.assign(response.data);
        this[config.stateProp] = 'ok';
      }).catch(() => {
        if (chainSeq !== this[config.seqProp]) return;
        config.assign([]);
        if (typeof navigator !== 'undefined' && navigator.onLine === false) {
          this[config.stateProp] = 'error'; // el listener de 'online' refresca al volver
          return;
        }
        if (attempt < 2) {
          const delayMs = attempt === 0 ? 1000 : 3000;
          this[config.timerProp] = setTimeout(() => {
            if (chainSeq === this[config.seqProp]) {
              this.loadListWithRecovery(config, attempt + 1, chainSeq);
            }
          }, delayMs);
          return; // sigue en 'loading' durante el backoff
        }
        this[config.stateProp] = 'error';
      });
    },
    loadBanks() {
      // Sin país real elegido (placeholder "0" del select, o el form recién
      // abierto) no hay nada que cargar: no mostrar estados de carga/error
      // sobre un país que no existe.
      if (!Number(this.form.country_id)) {
        this.banks = [];
        this.bankLoadState = 'idle';
        return;
      }

      this.loadListWithRecovery({
        stateProp: 'bankLoadState',
        seqProp: 'bankLoadSeq',
        timerProp: 'bankRetryTimer',
        request: () => FormApi.getBanksByCountry(this.form.country_id),
        assign: (list) => {
          this.banks = list;
          if (list.length === 1) {
            this.form.destination_account_bank_id = list[0].id;
          }
        },
      });
    },
    // La lista de países (o de activos, en cripto) es la puerta de entrada del
    // formulario: sin ella no se puede elegir país -> ni banco -> ni guardar
    // un destinatario. Merece exactamente la misma recuperación.
    loadCountries() {
      this.loadListWithRecovery({
        stateProp: 'countryLoadState',
        seqProp: 'countryLoadSeq',
        timerProp: 'countryRetryTimer',
        request: () => FormApi.getAllCountries(this.isBank),
        assign: (list) => { this.countries = list; },
      });
    },
    retryLoadBanks() {
      this.loadBanks();
    },
    retryLoadCountries() {
      this.loadCountries();
    },
    // Cancela las cadenas vigentes (timers + respuestas en vuelo) y vuelve a
    // 'idle': para cuando el flujo de listas deja de ser relevante (p.ej. al
    // pasar a Cuenta Arcadi, que no usa países ni bancos).
    cancelBankLoad() {
      this.bankLoadSeq += 1;
      this.countryLoadSeq += 1;
      if (this.bankRetryTimer) {
        clearTimeout(this.bankRetryTimer);
        this.bankRetryTimer = null;
      }
      if (this.countryRetryTimer) {
        clearTimeout(this.countryRetryTimer);
        this.countryRetryTimer = null;
      }
      this.bankLoadState = 'idle';
      this.countryLoadState = 'idle';
    },
    handleConnectionRestored() {
      if (this.countryLoadState === 'error') this.loadCountries();
      if (this.bankLoadState === 'error') this.loadBanks();
    },
    initComponent(category) {
      const form = {
        alias: "",
        recipient_first_name: "",
        recipient_last_name: "",
        recipient_id_type: "",
        recipient_id: "",
        category: category,
        country_id: 0,
        aba_number: "",
        iban_number: "",
        cpf_number: "",
        pix_key: "",
        recipient_city: "",
        recipient_state: "",
        recipient_home_address: "",
        recipient_phone: "",
        recipient_birthdate: "",
        destination_account_bank_id: 0,
        account_type: this.destinationAccount.account_type || '',
        recipient_email: "",
        additional_data: "",
        number: "",
        personal_account: false,
        arcadi_email: "",
        arcadi_alias: ""
      };

      this.banks = [];
      this.form = form;
      if (this.destinationAccount.id) this.newUser = false;
      if (this.destinationAccount.user_id || this.destinationAccount.personal_account) {
        if (this.destinationAccount.category === category) {
          this.form = { ...this.destinationAccount }
          this.form.country_id = this.accountCountryCode;
          this.form.destination_account_bank_id = this.destinationAccount.destination_account_bank_id || 0;
        } else {
          this.form.alias = this.destinationAccount.alias
        }
      }
      if (category !== 'arcadi') {
        this.loadCountries();
        this.getBankByCountry();
      }
    },
    getFormElement() {
      return this.$el.closest('form');
    },
    translateIdentity(identity) {
      const identityOptions = {
        "Cédula de identidad": this.$t("add_contact_page.form.identification_type.identity_card"),
        "Cédula de extranjero": this.$t("add_contact_page.form.identification_type.foreigner_card"),
        "Cédula de empresa": this.$t("add_contact_page.form.identification_type.company_card"),
        "Pasaporte": this.$t("add_contact_page.form.identification_type.passport"),
      }
      return identityOptions[identity];
    }
  },
  watch: {
    'form.category'(newCategory, oldCategory) {
      if (!oldCategory) return;
      if (newCategory === 'arcadi') {
        // Cuenta Arcadi no usa bancos: irse de esa sección es una entrada
        // nueva más — invalida la cadena vigente para que un backoff armado
        // no siga reintentando (ni un evento 'online' reviva nada) contra un
        // país que el usuario ya abandonó, sobre un subtree oculto.
        this.cancelBankLoad();
        this.originalFormAction = this.originalFormAction || this.getFormElement()?.getAttribute('action');
        const formEl = this.getFormElement();
        if (formEl) {
          formEl.setAttribute('action', '/internal_contacts');
        }
        const saveButton = document.querySelector("#save-button-destination_account");
        if (saveButton) {
          saveButton.disabled = false;
        }
      } else {
        if (this.originalFormAction) {
          const formEl = this.getFormElement();
          if (formEl) {
            formEl.setAttribute('action', this.originalFormAction);
          }
        }
        this.initComponent(newCategory);
      }
    },
    infoChecked() {
      const saveButton = document.querySelector(
        "#save-button-destination_account"
      );
      if (saveButton && !this.isArcadi) {
        saveButton.disabled = !this.infoChecked;
      }
    }
  }
};
</script>

<style scoped>
.error-destination {
  color: #e1374b;
  margin-top: 0.5rem;
  margin-bottom: 0.75rem;
  font-size: 0.75rem;
}

.arcadi-input:disabled {
  background-color: #fff;
  color: #7c7d7f;
  cursor: not-allowed;
}

input[type="radio"] {
  accent-color: var(--background-color-complementary);
}

/* ---- Selector "Tipo de cuenta" (categoría del destinatario) ----
   Tres opciones seleccionables tipo tarjeta (banco / cripto / Arcadi) en lugar
   de radios planos. Acento púrpura estable (--background-color-tertiary) en
   ambos temas; los colores de texto usan --font-color-primary que ya rota por
   tema, así que sólo se ajustan bordes/tints en dark. */
.dac-category {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  margin-bottom: 0.25rem;
}

.dac-option {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.85rem;
  padding: 0.85rem 1rem;
  border-radius: 16px;
  cursor: pointer;
  border: 1.5px solid rgba(30, 33, 35, 0.14);
  background: var(--background-color-primary);
  transition: border-color 160ms ease, background 160ms ease,
    box-shadow 160ms ease, transform 160ms ease;
}

.dac-option:hover {
  border-color: rgba(97, 29, 233, 0.45);
  transform: translateY(-1px);
}

.dac-option:active {
  transform: translateY(0);
}

.dac-option--selected {
  border-color: var(--background-color-tertiary);
  background: rgba(97, 29, 233, 0.07);
  box-shadow: 0 4px 14px rgba(97, 29, 233, 0.16);
}

/* Radio real: accesible al teclado pero invisible; el estado visual lo maneja
   la clase --selected (Vue) y el foco se refleja vía :has en la tarjeta. */
.dac-option__input {
  position: absolute;
  opacity: 0;
  width: 1px;
  height: 1px;
  pointer-events: none;
}

.dac-option:has(.dac-option__input:focus-visible) {
  outline: 2px solid var(--background-color-tertiary);
  outline-offset: 2px;
}

.dac-option__icon {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  border-radius: 12px;
  font-size: 22px;
  background: rgba(97, 29, 233, 0.10);
  color: var(--background-color-tertiary);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.12);
  transition: background 160ms ease, color 160ms ease, box-shadow 160ms ease;
}

.dac-option--selected .dac-option__icon {
  background: var(--background-color-tertiary);
  color: #fff;
}

.dac-option__text {
  display: flex;
  flex-direction: column;
  gap: 0.12rem;
  flex: 1 1 auto;
  min-width: 0;
}

.dac-option__title {
  font-weight: 500;
  font-size: 0.98rem;
  line-height: 1.25;
  color: var(--font-color-primary);
}

.dac-option__desc {
  font-size: 0.8rem;
  line-height: 1.3;
  color: var(--font-color-primary);
  opacity: 0.6;
}

.dac-option__radio {
  position: relative;
  flex: 0 0 auto;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid rgba(30, 33, 35, 0.28);
  transition: border-color 160ms ease;
}

.dac-option--selected .dac-option__radio {
  border-color: var(--background-color-tertiary);
}

.dac-option--selected .dac-option__radio::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--background-color-tertiary);
  transform: translate(-50%, -50%);
}

/* Dark mode: bordes y tints (los colores de texto ya rotan vía tokens). */
[data-theme="dark"] .dac-option {
  border-color: rgba(249, 249, 249, 0.16);
  background: rgba(255, 255, 255, 0.03);
}

[data-theme="dark"] .dac-option--selected {
  background: rgba(97, 29, 233, 0.22);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.35);
}

/* Badge del icono en dark mode, sólo sin seleccionar (el seleccionado queda
   púrpura sólido vía .dac-option--selected .dac-option__icon). */
[data-theme="dark"] .dac-option:not(.dac-option--selected) .dac-option__icon {
  background: rgba(0, 0, 0, 0.10);
  color: #878787;
}

[data-theme="dark"] .dac-option__icon {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.35);
}

[data-theme="dark"] .dac-option__radio {
  border-color: rgba(249, 249, 249, 0.30);
}
</style>
